import React, { useEffect, useState, SetStateAction, Dispatch } from 'react';
import { Card, Row, Form, message, Col, Select, Button, Modal } from 'antd';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { getOTACodes } from './../../../../../services/common';
import { saveOrUpdatePolicyCheckoutCharge } from './../../../../../services/policy';
import Loading from './../../../../Loading';
import Input from '@ui/Input'
import TextArea from '@ui/TextArea';
import { LocalPersistence } from '@factories/index';
import Grid from '@material-ui/core/Grid';
interface CURoptionsType {
    codeName: string,
    codeType: string,
    codeValue: string,
    id: number,
    subCat: string | number | null
}
interface checkoutChargeType {
    description?: string, 
    chargetype: string, 
    currency?: string | null, 
    charge?: string | null, 
    policytype?: string | null
}
interface propsTypes {
    isEditable: ()=>void,
    cancelEditable: ()=>void,
    setOperationType: Dispatch<SetStateAction<string>>,
    detailData: {
      data: [],
      row: {
        rowIndex: number,
        chargetype: string,
        charge: string,
        policytype: string,
        description: string,
        currency: string
      },
      action: string
    }[],
    supplier: string,
    propertyid: string,
    getPoliciesData: () => {},
    setPoliciesData: Dispatch<SetStateAction<string | null>>,
}

const CheckOutChargeEdit = (props: propsTypes) => {
  const FormItem = Form.Item;
  const Option = Select.Option;
  const [currentOptions, setCurrentOptions] = useState<CURoptionsType[]>([])
  const [form] = Form.useForm()
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [required, setRequired] = useState(false)
  const [disableFlag, setDisableFlag] = useState(false)
  const [edit, setEdit] = useState(false) 
  const [chargeName, setChargeName] = useState<string>(`Charge (${props?.detailData[0].row.chargetype})`); 
  const [chargeValue, setChargeValue] = useState<string>('')
  const BALANCEOFSTAY = 'Charge (Balance of Stay)'

  const getCurrentOptions = async () => {
      setLoadingFlag(true)
      const res = await getOTACodes('CUR', '')
      if (res.result.success) {
          setCurrentOptions(res.otacodes)
      } else {
          setCurrentOptions([])
      }
      setLoadingFlag(false)
  }
  const validateForm = () => {
      form.validateFields().then(() => {
          setDisableFlag(false)
      }).catch(err => {
          err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
      });
  }
  const updateCheckoutChange = () => {
      form.validateFields().then( async (values) => {
          const get_session = new LocalPersistence('session')
          const session: any = await get_session.getSessionPersistence();
          setLoadingFlag(true)
          const dt: any = props.detailData[0].data
          if (props.detailData[0].action === 'edit') {
            dt[props.detailData[0].row.rowIndex] = values
          } else {
            dt.push(values)
          }
          const requestBody = {
              supplier: session.supplier,
              propertyId: session.propertyId,
              property: {
                  policies: {
                      checkoutcharge: dt
                  }
              }
          }
          saveOrUpdatePolicyCheckoutCharge(requestBody).then(
              res => {
                  if (res.result.success) {
                      setLoadingFlag(false)
                      props.cancelEditable();
                      props.setOperationType('view');
                      props.setPoliciesData(null)
                      props.getPoliciesData();
                  } else {
                      setLoadingFlag(false)
                      message.error({
                          content: res?.error[0]?.message
                      });
                  }

              },
              err => {
                  setLoadingFlag(false)
                  message.error({
                      content: err?.message || err?.error[0]?.message
                  });
                  props.cancelEditable();
              }
          )

      })
  }

  const deleteCheckoutCharge = async () => {
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence();
    setLoadingFlag(true)
    const dt: any = props.detailData[0].data
    const updatedDt = dt.filter((_: any, index: number) => index !== props.detailData[0].row?.rowIndex)
    const requestBody = {
      supplier: session.supplier,
      propertyId: session.propertyId,
      property: {
          policies: {
              checkoutcharge: updatedDt
          }
      }
  }
  saveOrUpdatePolicyCheckoutCharge(requestBody).then(
      res => {
          if (res.result.success) {
              setLoadingFlag(false)
              props.cancelEditable();
              props.setOperationType('view');
              props.setPoliciesData(null)
              props.getPoliciesData();
          } else {
              setLoadingFlag(false)
              message.error({
                  content: res?.error[0]?.message
              });
          }

      },
      err => {
          setLoadingFlag(false)
          message.error({
              content: err?.message || err?.error[0]?.message
          });
          props.cancelEditable();
      }
  )
  }

  const handleOk = async () => {
    setLoadingFlag(true)
    await deleteCheckoutCharge();
    setLoadingFlag(false)
    props.cancelEditable();
    props.setOperationType('view');
    props.setPoliciesData(null)
    props.getPoliciesData();
  };

  const ModalHead = () => {
    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          height: '50px',
          lineHeight: '50px',
          textIndent: '10px',
          borderBottom: '1px solid #ccc',
          color: '#fff',
          background: '#06789D',
          fontSize: 18,
          width: '100%',
        }}>
        Confirm
      </div>
    )
  }

  const deleteClick = async () => {
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      getContainer: '#ModalContainer',
      transitionName: '',
      maskTransitionName: '',
      onOk: async() => await handleOk(),
      onCancel() {},
    })
  }

  const onCancelClick = () => {
    if (props.detailData[0].action === 'add') {
      props.setOperationType('view')
    } else {
      setEdit(false)
      console.log(props.detailData[0])
      form.setFieldsValue({
          policytype: props.detailData[0].row.policytype,
          chargetype: props.detailData[0].row.chargetype,
          charge: props.detailData[0].row.charge,
          currency: props.detailData[0].row?.currency,
          description: props.detailData[0].row.description,
      })
      setChargeName(`Charge (${props.detailData[0].row.chargetype ? props.detailData[0].row.chargetype : ''})`);
      setChargeValue(`${props.detailData[0].row.chargetype}`)
      
    } 
  }

  useEffect(() => {
      getCurrentOptions()
      if (props.detailData[0].action === 'add') {
        validateForm()
      }
  }, [])

  useEffect(() => {

    if(chargeValue === '' || chargeValue === "undefined"){
      setRequired(false)
    } else {
      setRequired(true)
    }
    if (edit) 
      validateForm()
  },[edit, chargeName, chargeValue])

  return (
    <>
      <PageContainer>
        <Card 
          style={{ marginTop: -15, marginBottom: 65, paddingLeft: -8 }}
          id='ModalContainer'
        >
          { props.detailData[0].action === 'edit' && !edit && <Grid item xs={12} className='p-0'>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ margin: '0 10px 0 0' }}>
                  <Button
                  className='db-edit-btn'
                  onClick={() => {
                    props.setOperationType('view')
                  }}>
                  Back
                  </Button>
              </div>
              <div>
                  <Button
                  className='db-edit-btn'
                  onClick={() => {
                      setEdit(true)
                  }}>
                  Edit
                  </Button>
              </div>
            </div>
          </Grid>}
          <Form
            form={form}
            layout='vertical'
            initialValues={{ ...props?.detailData[0].row }}
            onValuesChange={validateForm}
            style={{
              pointerEvents: edit || props.detailData[0].action === 'add' ? 'inherit' : 'none'
            }}>
            <Row gutter={24}>
              <Col span={6}>
                <FormItem 
                  name="policytype" 
                  label="Policy Type" 
                  rules={[{ required: true, message: 'This field is required' }]}
                >
                    <Select allowClear={true} showSearch>
                        <Option value="Early">Early</Option>
                        <Option value="Late">Late</Option>
                    </Select>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem 
                  name="chargetype" 
                  label="Charge Type" 
                >
                    <Select 
                      allowClear={true} 
                      onClear = {()=>{
                        setChargeValue('')
                      }}
                      onChange={value => {
                        setChargeName(`Charge (${value ? value : ''})`);
                        setChargeValue(`${value}`)
                        form.setFieldsValue({
                          charge: ''
                        })
                      }}
                      showSearch>
                      <Option value="Amount">Amount</Option>
                      <Option value="Percent">Percent</Option>
                      <Option value="Nights">Nights</Option>
                      <Option value="Balance of Stay">Balance of Stay</Option>
                    </Select>
                </FormItem>
              </Col>
              {
                chargeName !== BALANCEOFSTAY? 
                <Col span={6} 
                className="col-margin" >
                  <Form.Item 
                    name="charge" 
                    label={chargeName} 
                    rules={[
                        { 
                          required: required, 
                          message: 'This field is required' 
                        },
                        { 
                          pattern: chargeName === 'Charge (Nights)' ? /^\d*$/ : /^\d*(\.\d*)?$/, 
                          message: 'This field should be a number.' 
                        },
                    ]}
                  >
                      <Input  />
                  </Form.Item>
                </Col>
                :
                <Col span={6} 
                className="col-margin" >
                  <Form.Item 
                    name="charge"
                    label={chargeName} 
                    rules={[{ 
                      required: true, 
                      message: 'This field is required' 
                  }]}>
                    <Select allowClear showSearch>
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
            }
            <Col span={6}></Col>
            <>
                {
                    chargeName === 'Charge (Amount)' && <>
                        <Col span={6} className="col-margin">
                            <Form.Item 
                              name={"currency"} 
                              label="Currency" 
                              rules={[
                                { 
                                  required: true, 
                                  message: 'This field is required' 
                                },
                              ]}>
                                <Select allowClear showSearch
                                    placeholder="Select a currency"
                                    optionFilterProp="children"
                                    // @ts-expect-error
                                    filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {currentOptions.map((item: {codeName:string,codeValue:string}) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}></Col>
                    </>
                }
            </>
              <Col span={18} className="col-margin">
                  <Form.Item
                      name={"description"}
                      label="Description"
                      rules={[{ max: 300, message: 'You have reached the max character length of 300' }]}
                  >
                      <TextArea maxLength={300} minRows={3} />
                  </Form.Item>
              </Col>
              <Col span={6}></Col>
            </Row>
          </Form>
        </Card>
        {(edit || props.detailData[0].action === 'add') && <ActionButtonsBar
          onCancel={onCancelClick}
          onSave={updateCheckoutChange}
          disabledSave={disableFlag}
          onDelete={ props.detailData[0].action === 'edit' ? deleteClick : false }
        />}
      </PageContainer>
      {loadingFlag && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
          }}>
          <Loading type='large' />
        </div>
      )}
    </>
  )
}

export default CheckOutChargeEdit;


